import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { FuseConfigService } from '@fuse/services/config.service';
import { fromEvent, merge, Subject } from 'rxjs';
import { debounceTime, filter, startWith, switchMap, takeUntil } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { NotificationsApi } from '../../core/api/notifications.api';
import { Account } from '../../core/interfaces';
import { SocketService } from '../../core/services/socket.service';

@Component({
  selector: 'vertical-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class VerticalLayoutComponent implements OnInit, OnDestroy {
  fuseConfig: any;
  navigation: any;

  private unsubscribeAll$ = new Subject();
  public unreadNotificationsCount = 0;
  private subscriptions = new Subject<void>();

  sidebarOpen = true;

  constructor(
    private readonly fuseConfigService: FuseConfigService,
    private readonly authenticationService: AuthenticationService,
    private readonly notificationsApi: NotificationsApi,
    private readonly socketService: SocketService,

  ) {
  }

  ngOnInit(): void {
    this.fuseConfigService.config
      .pipe(takeUntil(this.unsubscribeAll$))
      .subscribe((config) => {
        this.fuseConfig = config;
      });

    merge(
      fromEvent(window, 'refresh-notification-count'),
      this.socketService.realtimeNotification$,
    ).pipe(
      startWith({}),
      takeUntil(this.subscriptions),
      filter(() => !!this.authenticationService.accessToken),
      switchMap(() => this.notificationsApi.getNotificationsUnreadCount())
    ).subscribe((count) => {
      this.unreadNotificationsCount = count;
    });
  }

  ngOnDestroy(): void {
    this.unsubscribeAll$.next();
    this.unsubscribeAll$.complete();
  }


  get account(): Account {
    return this.authenticationService.user && this.authenticationService.user.account;
  }

  get permissions(): string[] {
    return this.authenticationService.permissions;
  }

  get environment(): any {
    return environment;
  }

  get language(): string {
    return window.navigator.language;
  }

  get user(): any {
    return this.authenticationService.user;
  }

  toggleSidebar($event: any): void {
    this.sidebarOpen = !$event.detail;
  }

}
